import React, { useState } from 'react';
import {useNavigate} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { IMAGES } from '../layout/theme';
import MainBanner from '../components/MainBanner';
import Features from '../components/Features';
import AboutBlog from '../components/AboutBlog';
import WithUs from '../components/WithUs';
import ServicesList from '../components/ServicesList';
import PriceList from '../components/PriceList';
import TestimonialBlog from '../components/TestimonialBlog';
import TouchStart from '../components/TouchStart';
import OurBlog from '../components/OurBlog';
import AccordionBlog from '../components/AccordionBlog';
import contactLeadService from '../services/contactLeadService';

const Home = () => {
    const { t } = useTranslation();
    const Nav = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>){
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);
        const email = formData.get('dzEmail') as string;

        if (!email) {
            return;
        }

        setIsSubmitting(true);

        try {
            // Save email to contact_leads table
            await contactLeadService.create({
                contact: email,
                source: 'website-banner'
            });

            // Reset form
            form.reset();

            // Show success message
            Swal.fire({
                title: 'Success!',
                text: 'Thank you! We will contact you soon.',
                icon: 'success',
                confirmButtonColor: '#d89d37'
            });
        } catch (error: any) {
            console.error('Error submitting email:', error);
            Swal.fire({
                title: 'Error',
                text: error?.response?.data?.error || 'Failed to submit. Please try again.',
                icon: 'error',
                confirmButtonColor: '#d89d37'
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    // FAQ data for homepage - top 6 most important questions
    const homeFaqData = [
        { title: t('faqPage.q1'), content: t('faqPage.a1') },
        { title: t('faqPage.q2'), content: t('faqPage.a2') },
        { title: t('faqPage.q3'), content: t('faqPage.a3') },
        { title: t('faqPage.q6'), content: t('faqPage.a6') },
        { title: t('faqPage.q11'), content: t('faqPage.a11') },
        { title: t('faqPage.q14'), content: t('faqPage.a14') },
    ];

    return (
        <>
            <section className="main-banner" id="main-banner">
                <MainBanner />
                <div className="container">
                    <div className="rocket-img active-rocket">
                        <img src={IMAGES.logoWithOuuText} alt="Rocket" className="logo-rocket"  />
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-9">
                            <div className="banner-content">
                                <h1 className="h1-title wow fadeup-animation">  <span>{t('home.bannerTitle')}</span></h1>
                                <div className="banner-form wow fadeup-animation" >
                                    <form className="dzSubscribe" onSubmit={handleSubmit}>
                                        <div className="dzSubscribeMsg"></div>
                                        <div className="form-box">
                                            <input name="dzEmail" required type="text" placeholder={t('home.bannerPlaceholder')} disabled={isSubmitting} />
                                            <button name="submit" value="Submit" type="submit" className="sec-btn" disabled={isSubmitting}>
                                                <span>{isSubmitting ? 'Sending...' : t('home.bannerButton')}</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/*  Aboout Us Start  */}
            <section className="main-about-us">
                <AboutBlog />
            </section>


            {/*  Services Start  */}
            <section className="main-services">
                <div className="container-md">
                    <div className="row">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title" id="services">{t('home.servicesSubtitle')}</span>
                                <h1 className="h1-title">{t('home.servicesTitle')}</h1>
                            </div>
                        </div>
                    </div>
                    <ServicesList />
                </div>
            </section>

            {/* Pricing Plan Start */}
            <section className="main-pricing">
                <div className="container">
                    <PriceList />
                </div>
            </section>

            {/* <!-- More With Us Start --> */}
            <section className="main-with-us">
                <WithUs />
            </section>

            <section className="main-testimonial">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('home.testimonialSubtitle')}</span>
                                <h2 className="h2-title">{t('home.testimonialTitle')}</h2>
                            </div>
                        </div>
                    </div>
                    <TestimonialBlog />
                </div>
            </section>






            {/* <!-- Get In Touch Start --> */}
            <section className="main-contact">
                <div className="container">
                    <TouchStart />
                </div>
            </section>



            {/* FAQ Section Start */}
            <section className="main-faq-content" style={{ background: '#ffffff' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="center-title">
                                <span className="sub-title">{t('home.faqSubtitle')}</span>
                                <h2 className="h2-title" style={{ marginTop: '15px', marginBottom: '10px' }}>{t('home.faqTitle')}</h2>
                                <p style={{ color: '#5a6c7d', fontSize: '18px', maxWidth: '700px', margin: '0 auto 20px' }}>
                                    Find answers to common questions about our property management services
                                </p>
                            </div>
                            <div className="faq-accordion accordion-style">
                                <div className="row">
                                    <div className="col-lg-10 offset-lg-1">
                                        <AccordionBlog arrayData={homeFaqData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/*  Our Blog Start  */}
            <section className="main-our-blog">
                <OurBlog />
            </section>
        </>
    );
};

export default Home;